import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de frais PayPal - Calculez les commissions PayPal";
const DESCRIPTION =
  "Calculatrice PayPal gratuite : calculez les frais PayPal pour n importe quelle transaction. Connaissez le montant net recu ou le montant a envoyer pour que le destinataire recoit la somme exacte voulue.";
const KEYWORDS =
  "calculatrice frais paypal, frais paypal transaction, montant net paypal, commission paypal, calcul paiement paypal";
const OG_URL = "https://do-calculate.com/calculator/fr/paypal-fee/";

const FIXED_FEES = {
  standard:     { rate: 0.0349, fixed: 0.49, name: "Transaction commerciale standard" },
  checkout:     { rate: 0.0299, fixed: 0.49, name: "PayPal Checkout" },
  micropayment: { rate: 0.05,   fixed: 0.05, name: "Micropaiements" },
  friends:      { rate: 0.0,    fixed: 0.00, name: "Amis et famille" },
  international:{ rate: 0.045,  fixed: 0.49, name: "Virement international" },
};

const CALC_MODE = {
  sender:   "Je veux envoyer un montant (combien arrive au destinataire ?)",
  receiver: "Je veux qu un montant exact arrive (combien envoyer ?)",
};

function PaypalFeeCalculator() {
  const [amount, setAmount] = useState("");
  const [transactionType, setTransactionType] = useState("standard");
  const [calcMode, setCalcMode] = useState("sender");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateResult = () => {
    try {
      setError("");
      const amountNum = parseFloat(amount);
      if (!amountNum || amountNum <= 0) { setResult(null); return; }

      const txConfig = FIXED_FEES[transactionType];
      const rate = txConfig.rate;
      const fixedFee = txConfig.fixed;

      let feePaid, amountSent, amountReceived;

      if (calcMode === "sender") {
        amountSent = amountNum;
        feePaid = amountSent * rate + fixedFee;
        amountReceived = amountSent - feePaid;
      } else {
        amountReceived = amountNum;
        amountSent = (amountReceived + fixedFee) / (1 - rate);
        feePaid = amountSent - amountReceived;
      }

      if (amountReceived < 0) {
        setError("Le montant est inferieur aux frais fixes ! Veuillez entrer un montant plus eleve.");
        setResult(null); return;
      }

      const feePercentage = amountSent > 0 ? (feePaid / amountSent) * 100 : 0;

      setResult({
        amountSent: amountSent.toFixed(2),
        amountReceived: amountReceived.toFixed(2),
        feePaid: feePaid.toFixed(2),
        feePercentage: feePercentage.toFixed(2),
        fixedFee: fixedFee.toFixed(2),
        ratePercent: (rate * 100).toFixed(2),
        transactionName: txConfig.name,
        mode: calcMode,
      });
    } catch (err) {
      setError("Erreur de calcul. Veuillez verifier les donnees saisies.");
      setResult(null);
    }
  };

  useEffect(() => { if (amount) calculateResult(); }, [amount, transactionType, calcMode]);

  const handleClear = () => {
    setAmount(""); setTransactionType("standard"); setCalcMode("sender"); setResult(null); setError("");
  };

  return (
    <div className="ltr" style={{ direction: "ltr" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row"><div className="col-12 col-md-8"><FirstAds /></div></div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ padding: "15px", borderRadius: "5px" }}>
            <h1 style={{ fontSize: "22px", margin: 0 }}>Calculatrice de frais PayPal</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>La calculatrice PayPal</strong> est un outil gratuit et precis pour{" "}
                <strong>calculer les frais PayPal</strong> de n&apos;importe quelle transaction. Que vous soyez
                vendeur, freelance ou acheteur, entrez le montant, choisissez le type de transaction
                et obtenez instantanement les frais et le montant net.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Calculez vos frais PayPal</h2>
              </div>

              <div className="row mb-3">
                <div className="col-sm-12">
                  <label><strong>Mode de calcul :</strong></label>
                  <select className="form-select mb-2" value={calcMode} onChange={(e) => setCalcMode(e.target.value)}>
                    {Object.entries(CALC_MODE).map(([k, v]) => (
                      <option key={k} value={k}>{v}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-sm-12">
                  <label><strong>Type de transaction :</strong></label>
                  <select className="form-select" value={transactionType} onChange={(e) => setTransactionType(e.target.value)}>
                    {Object.entries(FIXED_FEES).map(([k, v]) => (
                      <option key={k} value={k}>{v.name} — {(v.rate * 100).toFixed(2)}% + {v.fixed.toFixed(2)} $</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-sm-12 col-md-6">
                  <label>{calcMode === "sender" ? "Montant a envoyer" : "Montant que le destinataire doit recevoir"}</label>
                  <input type="number" className="form-control" value={amount}
                    onChange={(e) => setAmount(e.target.value)} placeholder="Ex: 100" />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button onClick={handleClear} className="btn btn-secondary" style={{ padding: "10px 30px" }}>
                  Effacer les donnees
                </button>
              </div>

              {error && <div className="alert alert-warning"><strong>Attention :</strong> {error}</div>}

              {result && (
                <div className="mt-4">
                  <h3 className="text-center mb-3">Resultats — {result.transactionName}</h3>
                  <table className="table bmi-table">
                    <thead>
                      <tr>
                        <th>Element</th>
                        <th>Valeur</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Montant envoye</td>
                        <td style={{ fontWeight: "bold" }}>{result.amountSent} $</td>
                      </tr>
                      <tr>
                        <td>Frais variables ({result.ratePercent}%)</td>
                        <td>{((parseFloat(result.amountSent) * parseFloat(result.ratePercent)) / 100).toFixed(2)} $</td>
                      </tr>
                      <tr>
                        <td>Frais fixes</td>
                        <td>{result.fixedFee} $</td>
                      </tr>
                      <tr>
                        <td>Frais totaux</td>
                        <td style={{ fontWeight: "bold", color: "#d9534f" }}>{result.feePaid} $ ({result.feePercentage}%)</td>
                      </tr>
                      <tr>
                        <td>Montant net recu</td>
                        <td style={{ fontWeight: "bold", color: "#1a5f3f", fontSize: "18px" }}>{result.amountReceived} $</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <hr />
            <div className="row"><RelatedLinks /></div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds /><br />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Pourquoi utiliser cette calculatrice</div>
              <div className="info-section-body">
                <p>Elle permet de savoir si un montant facture couvre encore vos frais de plateforme avant de confirmer une vente, une mission ou un paiement international.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Utilisations de la calculatrice PayPal</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>Pour les independants et freelances :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Tarification des prestations :</strong> calculez le montant a facturer pour recevoir exactement la somme souhaitee.</li>
                  <li><strong>Facturation transparente :</strong> ajoutez les frais PayPal a votre facture client en toute clarte.</li>
                  <li><strong>Comparaison des moyens de paiement :</strong> evaluez si PayPal est plus economique que les virements bancaires.</li>
                  <li><strong>Calcul du revenu net :</strong> connaissez precisement ce que vous allez encaisser avant de valider une mission.</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Pour les e-commercants :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Definition de la marge :</strong> deduisez les frais PayPal de vos calculs de rentabilite en amont.</li>
                  <li><strong>Analyse des couts :</strong> estimez le total des frais mensuels sur la base de votre volume de ventes.</li>
                  <li><strong>Decisions strategiques :</strong> determinez quand PayPal est le meilleur choix et quand utiliser une alternative.</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Pour les transferts personnels :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Envoi de fonds :</strong> sachez exactement combien votre proche recevra a l&apos;etranger.</li>
                  <li><strong>Partage de depenses :</strong> calculez precisement la part de chacun avec les frais inclus.</li>
                  <li><strong>Transferts internationaux :</strong> comparez les frais PayPal avec les virements bancaires classiques.</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Types de transactions PayPal</div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Standard :</strong> transactions commerciales classiques (3,49 % + frais fixes)</li>
                  <li><strong>Checkout :</strong> paiements via le bouton PayPal Checkout (2,99 % + frais fixes)</li>
                  <li><strong>Micropaiements :</strong> petits montants (5 % + frais reduits)</li>
                  <li><strong>Amis et famille :</strong> envois personnels, sans frais</li>
                  <li><strong>International :</strong> virements transfrontaliers (4,5 % + frais fixes)</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Exemples pratiques de calcul des frais PayPal</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>Exemple 1 : Freelance qui facture 500 €</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Situation :</strong> un designer graphique veut recevoir 500 € pour un projet.</p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Calcul (transaction commerciale standard) :</strong><br />
                  Frais = (500 × 3,49 %) + 0,49 $ = 17,45 + 0,49 = <strong>17,94 $</strong><br />
                  Montant net recu = 500 - 17,94 = <strong>482,06 $</strong><br />
                  Pour recevoir 500 $ nets, le client doit envoyer : <strong>518,60 $</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Exemple 2 : Envoi de 200 € a un ami en Allemagne</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Situation :</strong> virement international entre particuliers.</p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Calcul (transfert international) :</strong><br />
                  Frais = (200 × 4,5 %) + 0,39 € = 9,00 + 0,39 = <strong>9,39 €</strong><br />
                  L&apos;ami recoit : 200 - 9,39 = <strong>190,61 €</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Exemple 3 : Paiement par PayPal Checkout pour un e-commerce</h3>
                <p style={{ lineHeight: "1.8" }}><strong>Situation :</strong> un client paie 300 € via le bouton PayPal Checkout integre dans le site.</p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Calcul (PayPal Checkout) :</strong><br />
                  Frais = (300 × 2,99 %) + 0,49 $ = 8,97 + 0,49 = <strong>9,46 $</strong><br />
                  Montant net encaisse = <strong>290,54 $</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Exemple 4 : Comparaison sur un petit montant de 5 €</h3>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Transaction standard :</strong> (5 × 3,49 %) + 0,49 = 0,17 + 0,49 = <strong>0,66 $</strong><br />
                  <strong>Micropaiements :</strong> (5 × 5 %) + 0,05 = 0,25 + 0,05 = <strong>0,30 $</strong><br />
                  <strong>Economie :</strong> 0,36 $ par transaction — significatif sur ce type de montant !
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Conseils pour reduire les frais PayPal</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>Pour les vendeurs et freelances :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Repercutez les frais :</strong> si le client exige PayPal, integrez le pourcentage des frais dans votre tarif.</li>
                  <li><strong>Privilegiez PayPal Checkout :</strong> le taux de 2,99 % est inferieur aux transactions standards (3,49 %).</li>
                  <li><strong>Regroupez les paiements :</strong> un seul versement important coute moins cher que plusieurs petits en frais fixes.</li>
                  <li><strong>Explorez PayPal Business :</strong> des tarifs negocies peuvent etre disponibles pour les gros volumes.</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>Erreurs courantes a eviter :</h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Ne demandez pas a l&apos;acheteur d&apos;utiliser "Amis et famille" pour eviter les frais — il perd la protection acheteur.</li>
                  <li>N&apos;oubliez pas les frais de conversion de devises (jusqu&apos;a 3-4 % supplementaires) pour les virements internationaux.</li>
                  <li>Ne calculez pas les frais uniquement sur le montant recu — la calculatrice les calcule depuis le montant envoye.</li>
                  <li>Verifiez toujours le type de transaction avant d&apos;envoyer un gros montant pour eviter les mauvaises surprises.</li>
                </ul>
                <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>⚠️ Rappel :</strong> Les frais PayPal peuvent changer. Consultez toujours les tarifs officiels sur le site PayPal avant toute transaction importante.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Lecture du resultat</div>
              <div className="info-section-body">
                <p>Le montant net correspond a la somme restante apres deduction des frais variables et fixes. C&apos;est la valeur la plus utile pour piloter votre rentabilite.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>Questions frequentes</h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Combien de frais PayPal sur 100 € ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Pour une transaction commerciale standard, les frais sur 100 € sont : (100 × 3,49 %) + 0,49 = 3,49 + 0,49 = <strong>3,98 €</strong>. Le destinataire recoit 96,02 €. Pour qu&apos;il recoit exactement 100 €, l&apos;expediteur doit envoyer environ <strong>104,12 €</strong>.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Peut-on envoyer de l&apos;argent gratuitement avec PayPal ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Oui, les transferts entre particuliers via l&apos;option "Amis et famille" sont gratuits si le financement provient du solde PayPal ou d&apos;un compte bancaire. En revanche, si vous utilisez une carte bancaire, des frais d&apos;environ 2,9 % s&apos;ajoutent. Les transferts internationaux comportent toujours des frais.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quelle est la difference entre transaction commerciale et personnelle sur PayPal ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>La transaction commerciale (Biens et services) s&apos;utilise pour les achats et inclut la protection acheteur et vendeur, mais engendre des frais (3,49 %). La transaction personnelle (Amis et famille) sert aux envois entre proches, est gratuite localement, mais n&apos;offre aucune protection en cas de litige.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>PayPal applique-t-il des frais supplementaires sur la conversion de devises ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Oui, PayPal ajoute une marge sur le taux de change, generalement entre 3 % et 4 % au-dessus du taux de reference. Ces frais s&apos;ajoutent aux frais de transaction. Pour les eviter, envoyez dans la devise du beneficiaire si possible, ou utilisez des services speciialises comme Wise pour les gros transferts internationaux.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment calculer le montant a facturer pour recevoir une somme nette precise ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Utilisez l&apos;option "Je veux recevoir un montant net precis" dans la calculatrice. Par exemple, si votre prestation vaut 200 € et que vous souhaitez les toucher integralement, la calculatrice indiquera que le client doit envoyer environ <strong>207,89 €</strong> pour la transaction standard.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quels sont les frais PayPal pour les boutiques en ligne ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Les boutiques utilisant PayPal Checkout beneficient d&apos;un taux de 2,99 % + frais fixes, inferieur au taux standard de 3,49 %. Les vendeurs a fort volume peuvent negocier des tarifs prefentiels directement avec PayPal via un compte Business avance.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>PayPal est-il securise pour les transactions importantes ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>PayPal offre une bonne protection pour les acheteurs et les vendeurs dans le cadre de transactions commerciales. Pour les gros montants, verifiez les plafonds de votre compte et n&apos;oubliez pas que PayPal peut temporairement limiter les comptes recents ayant des transactions inhabituellement importantes. Consultez toujours les politiques locales de PayPal avant les transferts consequents.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Les frais PayPal sont-ils deductibles fiscalement ?</h3></div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>Oui, en France les frais PayPal lies a l&apos;activite professionnelle sont generalement deductibles du benefice imposable au titre des charges d&apos;exploitation. Conservez vos releves PayPal comme justificatifs comptables. Consultez votre expert-comptable pour les regles specifiques a votre regime fiscal.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaypalFeeCalculator;
